import React, { useRef } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { SearchFilter, useSearchFiltersContext } from "../library/SearchFilter";
import { useOnClickOutside, useModal } from "../../hooks";

const SearchFilterContainer = (props: Props) => {
  const { children } = props;
  const popup = useModal();
  const { submit } = useSearchFiltersContext();

  const close = () => {
    popup.close();
    submit();
  };

  const togglePopup = () => (popup.isOpen ? close() : popup.open());

  const ref = useRef();
  useOnClickOutside(ref, close);

  return (
    <FilterButtonWrapper ref={ref}>
      <Button type="button" onClick={togglePopup}>
        <FilterIcon icon={faFilter} />
        Filters
      </Button>
      {popup.isOpen && (
        <SearchFilter onClose={popup.close}>{children}</SearchFilter>
      )}
    </FilterButtonWrapper>
  );
};

const FilterIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

const FilterButtonWrapper = styled.div`
  position: relative;
`;

const Button = styled.button`
  height: 100%;
  border: 0;
  background: none;
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.primaryLight};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 0.5rem 1rem;
  font-weight: 700;
  border-radius: 3px;
  transition: background-color ease-in-out 180ms;

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.colors.primaryLightHover};
  }
`;

type Props = {
  children: React.ReactNode;
};

export default SearchFilterContainer;
